import React from 'react';
import SkeletonCard from '../../../../components/Skeleton/Card';

export const LoadingEmployeeFeedbacks: React.FC<
  React.PropsWithChildren<unknown>
> = () => <SkeletonCard height={180} />;
